"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var tv4 = require('tv4');

var BioDetails = /*#__PURE__*/function () {
  function BioDetails(opt) {
    _classCallCheck(this, BioDetails);

    this.materialType = null;
    this.riskGroup = null;
    this.category = null;
    this.knownPathogens = null;
    this.naturalHost = null;
    this.naturalHost = null;
    this.exemptAmount = null;
    this.mouseLd50 = null;
    this.blp = null;

    if (opt) {
      this.fillObject(_objectSpread({}, opt));
    }
  }

  _createClass(BioDetails, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.materialType = opt.materialType || null;
      this.riskGroup = opt.riskGroup || null;
      this.category = opt.category || null;
      this.knownPathogens = opt.knownPathogens || null;
      this.naturalHost = opt.naturalHost || null;
      this.exemptAmount = opt.exemptAmount || null;
      this.mouseLd50 = opt.mouseLd50 || null;
      this.blp = opt.blp || null;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, BioDetails.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'library-item.bio.details.schema.json',
        title: 'Library Item Bio details Schema',
        type: 'object',
        additionalProperties: false,
        properties: {
          materialType: {
            type: ['string']
          },
          riskGroup: {
            type: ['string']
          },
          category: {
            type: ['string']
          },
          knownPathogens: {
            type: ['string', 'null']
          },
          naturalHost: {
            type: ['string', 'null']
          },
          exemptAmount: {
            type: ['string', 'null']
          },
          mouseLd50: {
            type: ['string', 'null']
          },
          blp: {
            type: ['string', 'null']
          }
        },
        required: Object.keys(new BioDetails())
      };
    }
  }]);

  return BioDetails;
}();

module.exports = BioDetails;